import {Record} from 'immutable';
import {schema} from 'normalizr';

const ThreadAttributeValue = Record({
    id: null,
    value: null,
    name: null,
    type: null,
});

export const ThreadAttributeValueSchema = new schema.Entity('threadAttributeValues');

export default ThreadAttributeValue;
